import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	method: null,
	wallet: null,
	isVisibleAddMethod: false,
	isVisibleUpdateAcc: false,
	isVisibleTaxInfo: false,
	editWallet: null,
	withdrawParams: null,
};

const withdrawSlice = createSlice({
	name: "withdraw",
	initialState,
	reducers: {
		drop: () => initialState,
		setMethod: (state, action) => {
			state.method = action.payload;
		},
		setWallet: (state, action) => {
			state.wallet = action.payload;
		},
		setVisibleAddMethod: (state, action) => {
			state.isVisibleAddMethod = action.payload;
		},
		setVisibleUpdateAcc: (state, action) => {
			state.isVisibleUpdateAcc = action.payload;
		},
		setIsVisibleTaxInfo: (state, action) => {
			state.isVisibleTaxInfo = action.payload;
		},
		updateWallet: (state, action) => {
			const { key, value } = action.payload;
			if (state.wallet !== null) {
				state.wallet = { ...state.wallet, [key]: value };
			}
			if (state.wallet == null) {
				state.wallet = { [key]: value };
			}
		},
		setWithdrawParams: (state, action) => {
			state.withdrawParams = action.payload;
			// state.isVisibleUpdateAcc = true;
		},
	},
});

export const withdrawActions = withdrawSlice.actions;
export const withdrawReducer = withdrawSlice.reducer;
